import React, { useState } from 'react';
import Layout from './components/PhotoGallery/Layout/Layout';
import MainView from './components/PhotoGallery/MainView';
import GalleryView from './components/PhotoGallery/GalleryView';
// Uploads disabled: uncomment this and the 'uploadPhotos' case below to turn them back on
// import UploadView from './components/PhotoGallery/UploadView';

const App = () => {
    const [currentView, setCurrentView] = useState('main');

    const renderView = () => {
        switch (currentView) {
            case 'main':
                return <MainView onViewChange={setCurrentView} />;
            case 'viewPhotos':
                return <GalleryView onBack={() => setCurrentView('main')} />;
            // case 'uploadPhotos':
            //     return <UploadView onBack={() => setCurrentView('main')} />;
            default:
                return <MainView onViewChange={setCurrentView} />;
        }
    };

    return (
        <Layout>
            {renderView()}
        </Layout>
    );
};

export default App;